import React from 'react';
import {DoppeDtoAction} from '../../client-server-common/types/doppe-dto-action';
import {DoppeViewerActionRenderer} from '../doppe-viewer-action-renderer/doppe-viewer-action-renderer';
import {DoppeViewerActionContext} from '../doppe-viewer-action-context/doppe-viewer-action-context';
import {
    useBymoPageViewerComponentsContext
} from '../bymo-page-viewer-components-context/bymo-page-viewer-components-context';
import {classes, style} from './doppe-viewer-action-popup.st.css';
import {FlexLayout} from '@wix/devzai-common-client';
import {
    useWidgetRenderingContext,
    WidgetRenderingContextType
} from '../../client-server-common/doppe-action-types/doppe-action-type';

export const DoppeViewerActionPopup = React.memo(function DoppeViewerActionPopup(props: DoppeViewerActionPopup.Props) {
    const {
        action,
        actionTogglingController,
        fullScreenModeTogglingController,
        actionIndex,
        className,
        ...htmlAttributes
    } = props;

    const bymoPageViewerComponentsContextData = useBymoPageViewerComponentsContext();

    const {
        widgetRenderingContextType
    } = useWidgetRenderingContext();


    return (
        <DoppeViewerActionRenderer
            action={action}
            actionIndex={actionIndex}
            actionTogglingController={actionTogglingController}
            fullScreenModeTogglingController={fullScreenModeTogglingController}
            ignoreActionViewedEvent={true}
        >

            {(actionContext, actionType) => {

                if (actionType.renderWidget === undefined) {
                    return (
                        <div>{`Action type with id '${action.actionTypeId}' doesn't support inline rendering.`}</div>
                    )
                } else {
                    return (
                        <div
                            {...htmlAttributes}
                            className={style(classes.root, {
                                isFullHeight: widgetRenderingContextType !== WidgetRenderingContextType.Card && widgetRenderingContextType !== WidgetRenderingContextType.Strip,
                            }, FlexLayout.column.default, className)}
                        >
                            {
                                actionType.renderWidget({
                                    actionContext: actionContext,
                                }, bymoPageViewerComponentsContextData.actionTypesViewerComponents.get(actionType.id))
                            }
                        </div>
                    )
                }
            }}

        </DoppeViewerActionRenderer>
    )
});

export namespace DoppeViewerActionPopup {

    export interface Props extends React.HTMLAttributes<any> {
        action: DoppeDtoAction;
        actionTogglingController?: DoppeViewerActionContext.ActionTogglingController;
        fullScreenModeTogglingController?: DoppeViewerActionContext.FullScreenModeTogglingController;
        actionIndex?: number;

    }

}